module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-en.88fd982.png";